var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,15.5c-1.6,0-3.1-1.1-3.5-2.7c-0.5-1.9,0.7-3.9,2.6-4.4C18,7.8,19.9,9,20.4,11s-0.7,3.9-2.6,4.4 C17.5,15.5,17.2,15.5,16.9,15.5z M16.9,9c-0.2,0-0.5,0-0.7,0.1c-1.5,0.4-2.4,1.9-2,3.4c0.4,1.5,1.9,2.4,3.4,2 c1.5-0.4,2.4-1.9,2-3.4C19.3,9.9,18.2,9,16.9,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,33.8L22,33.5C21.4,33.1,7.7,23.2,5.7,15.1C4.9,12,5.3,8.7,6.9,6c1.6-2.8,4.1-4.7,7.2-5.5 C20.3-1,26.7,2.9,28.3,9.4c2.1,8.1-5.4,23.4-5.7,24L22.4,33.8z M16.8,1c-0.8,0-1.7,0.1-2.5,0.3C11.5,2,9.1,3.8,7.6,6.4 C6.1,8.9,5.7,12,6.5,14.9c1.8,7.1,13.3,16,15.6,17.7c1.2-2.6,7.3-15.9,5.4-23l0,0C26.2,4.5,21.7,1,16.8,1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f5f129b094ddeee3cc07099bfe6bc406.svg";
export { ForwardRef as ReactComponent };